<div class="testimonials">
  <div class="box-all">
    @if (testimonialBefore != undefined) {
    <div class="box-people" (click)="moveTestimomnal(false)">
      <div class="icon-people">
        <img src="assets/images/home/testimonial_azul_icono.png" alt="Comentario de usuario" title="Testimonios" />
      </div>
      <div class="qualify">
        <i class="fa fa-star" aria-hidden="true" id="1star"
          [ngClass]="validarEstrella(1, testimonialBefore.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="2star"
          [ngClass]="validarEstrella(2, testimonialBefore.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="3star"
          [ngClass]="validarEstrella(3, testimonialBefore.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="4star"
          [ngClass]="validarEstrella(4, testimonialBefore.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="5star"
          [ngClass]="validarEstrella(5, testimonialBefore.qualify)"></i>
      </div>
      <p>{{testimonialBefore.description}}</p>
      <div class="d-flex">
        <p class="author">{{testimonialBefore.author}}</p>
      </div>
    </div>
    }
    @if (testimonialMain != undefined) {
    <div class="box-people">
      <div class="icon-people">
        <img src="assets/images/home/testimonial_azul_icono.png" alt="Comentario de usuario" title="Testimonios" />
      </div>
      <div class="qualify">
        <i class="fa fa-star" aria-hidden="true" id="1star" [ngClass]="validarEstrella(1, testimonialMain.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="2star" [ngClass]="validarEstrella(2, testimonialMain.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="3star" [ngClass]="validarEstrella(3, testimonialMain.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="4star" [ngClass]="validarEstrella(4, testimonialMain.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="5star" [ngClass]="validarEstrella(5, testimonialMain.qualify)"></i>
      </div>
      <p>{{testimonialMain.description}}</p>
      <div class="d-flex">
        <p class="author">{{testimonialMain.author}}</p>
      </div>
    </div>
    }
    @if (testimonialAfter != undefined) {
    <div class="box-people" (click)="moveTestimomnal(true)">
      <div class="icon-people">
        <img src="assets/images/home/testimonial_azul_icono.png" alt="Comentario de usuario" title="Testimonios" />
      </div>
      <div class="qualify">
        <i class="fa fa-star" aria-hidden="true" id="1star"
          [ngClass]="validarEstrella(1, testimonialAfter.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="2star"
          [ngClass]="validarEstrella(2, testimonialAfter.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="3star"
          [ngClass]="validarEstrella(3, testimonialAfter.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="4star"
          [ngClass]="validarEstrella(4, testimonialAfter.qualify)"></i>
        <i class="fa fa-star" aria-hidden="true" id="5star"
          [ngClass]="validarEstrella(5, testimonialAfter.qualify)"></i>
      </div>
      <p>{{testimonialAfter.description}}</p>
      <div class="d-flex">
        <p class="author">{{testimonialAfter.author}}</p>
      </div>
    </div>
    }
  </div>
</div>